import { MutableRefObject, useEffect } from 'react';
import { useFirstMountState } from 'react-use';

interface UseThumbnailFocusAndScrollProps {
  thumbnailsHaveKeyboardFocus: boolean;
  thumbnailRefs: MutableRefObject<HTMLAnchorElement[] | null[]>;
  currentImage: number;
  shouldScrollThumbnailIntoView: boolean;
}

export const useThumbnailFocusAndScroll = ({
  thumbnailsHaveKeyboardFocus,
  thumbnailRefs,
  currentImage,
  shouldScrollThumbnailIntoView,
}: UseThumbnailFocusAndScrollProps) => {
  const isFirstMount = useFirstMountState();

  useEffect(() => {
    const currentThumbnail = thumbnailRefs.current[currentImage];

    if (currentThumbnail && !isFirstMount) {
      if (thumbnailsHaveKeyboardFocus) {
        currentThumbnail.focus();
      }

      if (shouldScrollThumbnailIntoView) {
        currentThumbnail.scrollIntoView({
          block: 'nearest',
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentImage]);
};
